
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fees",
      function () {
        return require("private-next-pages/fees/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fees"])
      });
    }
  